(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5286],{

/***/ 12963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Breadcrumbs_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(59864);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/useSlotProps.js + 4 modules
var useSlotProps = __webpack_require__(56504);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 2 modules
var useThemeProps = __webpack_require__(27623);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(82066);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/MoreHoriz.js



/**
 * @ignore - internal component.
 */

/* harmony default export */ var MoreHoriz = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz'));
// EXTERNAL MODULE: ./node_modules/@mui/material/ButtonBase/ButtonBase.js + 4 modules
var ButtonBase = __webpack_require__(49990);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Breadcrumbs/BreadcrumbCollapsed.js


const _excluded = ["slots", "slotProps"];







const BreadcrumbCollapsedButton = (0,styled/* default */.ZP)(ButtonBase/* default */.Z)(({
  theme
}) => (0,esm_extends/* default */.Z)({
  display: 'flex',
  marginLeft: `calc(${theme.spacing(1)} * 0.5)`,
  marginRight: `calc(${theme.spacing(1)} * 0.5)`
}, theme.palette.mode === 'light' ? {
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.grey[700]
} : {
  backgroundColor: theme.palette.grey[700],
  color: theme.palette.grey[100]
}, {
  borderRadius: 2,
  '&:hover, &:focus': (0,esm_extends/* default */.Z)({}, theme.palette.mode === 'light' ? {
    backgroundColor: theme.palette.grey[200]
  } : {
    backgroundColor: theme.palette.grey[600]
  }),
  '&:active': (0,esm_extends/* default */.Z)({
    boxShadow: theme.shadows[0]
  }, theme.palette.mode === 'light' ? {
    backgroundColor: (0,colorManipulator/* emphasize */._4)(theme.palette.grey[200], 0.12)
  } : {
    backgroundColor: (0,colorManipulator/* emphasize */._4)(theme.palette.grey[600], 0.12)
  })
}));
const BreadcrumbCollapsedIcon = (0,styled/* default */.ZP)(MoreHoriz)({
  width: 24,
  height: 16
});

/**
 * @ignore - internal component.
 */
function BreadcrumbCollapsed(props) {
  const {
      slots = {},
      slotProps = {}
    } = props,
    otherProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = props;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbCollapsedButton, (0,esm_extends/* default */.Z)({
      focusRipple: true
    }, otherProps, {
      ownerState: ownerState,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbCollapsedIcon, (0,esm_extends/* default */.Z)({
        as: slots.CollapsedIcon,
        ownerState: ownerState
      }, slotProps.collapsedIcon))
    }))
  });
}
 false ? 0 : void 0;
/* harmony default export */ var Breadcrumbs_BreadcrumbCollapsed = (BreadcrumbCollapsed);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Breadcrumbs/breadcrumbsClasses.js


function getBreadcrumbsUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiBreadcrumbs', slot);
}
const breadcrumbsClasses = (0,generateUtilityClasses/* default */.Z)('MuiBreadcrumbs', ['root', 'ol', 'li', 'separator']);
/* harmony default export */ var Breadcrumbs_breadcrumbsClasses = (breadcrumbsClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Breadcrumbs/Breadcrumbs.js


const Breadcrumbs_excluded = ["children", "className", "component", "slots", "slotProps", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"];












const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    li: ['li'],
    ol: ['ol'],
    separator: ['separator']
  };
  return (0,composeClasses/* default */.Z)(slots, getBreadcrumbsUtilityClass, classes);
};
const BreadcrumbsRoot = (0,styled/* default */.ZP)(Typography/* default */.Z, {
  name: 'MuiBreadcrumbs',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    return [{
      [`& .${Breadcrumbs_breadcrumbsClasses.li}`]: styles.li
    }, styles.root];
  }
})({});
const BreadcrumbsOl = (0,styled/* default */.ZP)('ol', {
  name: 'MuiBreadcrumbs',
  slot: 'Ol',
  overridesResolver: (props, styles) => styles.ol
})({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  padding: 0,
  margin: 0,
  listStyle: 'none'
});
const BreadcrumbsSeparator = (0,styled/* default */.ZP)('li', {
  name: 'MuiBreadcrumbs',
  slot: 'Separator',
  overridesResolver: (props, styles) => styles.separator
})({
  display: 'flex',
  userSelect: 'none',
  marginLeft: 8,
  marginRight: 8
});
function insertSeparators(items, className, separator, ownerState) {
  return items.reduce((acc, current, index) => {
    if (index < items.length - 1) {
      acc = acc.concat(current, /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbsSeparator, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        children: separator
      }, `separator-${index}`));
    } else {
      acc.push(current);
    }
    return acc;
  }, []);
}
const Breadcrumbs = /*#__PURE__*/react.forwardRef(function Breadcrumbs(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiBreadcrumbs'
  });
  const {
      children,
      className,
      component = 'nav',
      slots = {},
      slotProps = {},
      expandText = 'Show path',
      itemsAfterCollapse = 1,
      itemsBeforeCollapse = 1,
      maxItems = 8,
      separator = '/'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, Breadcrumbs_excluded);
  const [expanded, setExpanded] = react.useState(false);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    expanded,
    expandText,
    itemsAfterCollapse,
    itemsBeforeCollapse,
    maxItems,
    separator
  });
  const classes = useUtilityClasses(ownerState);
  const collapsedIconSlotProps = (0,useSlotProps/* default */.Z)({
    elementType: slots.CollapsedIcon,
    externalSlotProps: slotProps.collapsedIcon,
    ownerState
  });
  const listRef = react.useRef(null);
  const renderItemsBeforeAndAfter = allItems => {
    const handleClickExpand = () => {
      setExpanded(true);

      // The clicked element received the focus but gets removed from the DOM.
      // Let's keep the focus in the component after expanding.
      // Moving it to the <ol> or <nav> does not cause any announcement in NVDA.
      // By moving it to some link/button at least we have some announcement.
      const focusable = listRef.current.querySelector('a[href],button,[tabindex]');
      if (focusable) {
        focusable.focus();
      }
    };

    // This defends against someone passing weird input, to ensure that if all
    // items would be shown anyway, we just show all items without the EllipsisItem
    if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
      if (false) {}
      return allItems;
    }
    return [...allItems.slice(0, itemsBeforeCollapse), /*#__PURE__*/(0,jsx_runtime.jsx)(Breadcrumbs_BreadcrumbCollapsed, {
      "aria-label": expandText,
      slots: {
        CollapsedIcon: slots.CollapsedIcon
      },
      slotProps: {
        collapsedIcon: collapsedIconSlotProps
      },
      onClick: handleClickExpand
    }, "ellipsis"), ...allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)];
  };
  const allItems = react.Children.toArray(children).filter(child => {
    if (false) {}
    return /*#__PURE__*/react.isValidElement(child);
  }).map((child, index) => /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    className: classes.li,
    children: child
  }, `child-${index}`));
  return /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbsRoot, (0,esm_extends/* default */.Z)({
    ref: ref,
    component: component,
    color: "text.secondary",
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadcrumbsOl, {
      className: classes.ol,
      ref: listRef,
      ownerState: ownerState,
      children: insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
    })
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Breadcrumbs_Breadcrumbs = (Breadcrumbs);

/***/ }),

/***/ 99690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MyBreadcrumbs; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12963);
/* harmony import */ var _mui_material_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23795);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);





function MyBreadcrumbs(_ref) {
  var routeList = _ref.routeList,
      inverted = _ref.inverted,
      t = _ref.t;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    "aria-label": "breadcrumb",
    separator: "\u203A",
    sx: {
      '.MuiBreadcrumbs-separator': {
        color: 'white'
      }
    },
    children: routeList.map(function (route) {
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        underline: "hover",
        color: inverted ? route.isActive ? '#DDDDDD' : 'white' : route.isActive ? 'text.primary' : "inherit",
        href: route.href,
        children: !!t ? t("home:".concat(route.label)) : route.label
      }, route.label);
    })
  });
}

/***/ }),

/***/ 89973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MySlider; }
/* harmony export */ });
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faChevronRight__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64746);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faChevronLeft__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75334);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Link__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(23795);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83321);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30719);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67814);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);














var MyPagination = function MyPagination(_ref) {
  var t = _ref.t;
  var swiper = (0,swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .useSwiper */ .oc)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(swiper.isBeginning),
      isBeginning = _useState[0],
      setIsBeginning = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(swiper.isEnd),
      isEnd = _useState2[0],
      setIsEnd = _useState2[1];

  swiper.on('slideChange', function () {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  });
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
    className: "flex justify-end mt-4",
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      variant: 'text',
      size: 'medium',
      disabled: isBeginning,
      className: "min-w-0 mr-2 text-black hover:text-primary",
      onClick: function onClick() {
        return swiper.slidePrev();
      },
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
        icon: _fortawesome_pro_solid_svg_icons_faChevronLeft__WEBPACK_IMPORTED_MODULE_8__/* .faChevronLeft */ .A3
      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      variant: 'text',
      size: 'medium',
      disabled: isEnd,
      className: "min-w-0 text-black hover:text-primary",
      onClick: function onClick() {
        return swiper.slideNext();
      },
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
        icon: _fortawesome_pro_solid_svg_icons_faChevronRight__WEBPACK_IMPORTED_MODULE_9__/* .faChevronRight */ ._t
      })
    })]
  });
};

function MySlider(_ref2) {
  var dataList = _ref2.dataList,
      title = _ref2.title,
      subTitle = _ref2.subTitle,
      showAll = _ref2.showAll,
      showArrows = _ref2.showArrows,
      href = _ref2.href,
      ItemComponent = _ref2.itemComponent,
      baseUrl = _ref2.baseUrl,
      brandInfo = _ref2.brandInfo,
      t = _ref2.t;

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      list = _useState3[0],
      setList = _useState3[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setList(dataList);
  }, [dataList]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
    className: "mb-7",
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
      className: "flex items-center mb-4",
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
        className: "font-semibold grow text-lg",
        children: title
      }), showAll ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_mui_material_Link__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        href: href,
        style: {
          alignSelf: 'flex-end',
          display: 'flex',
          textDecoration: 'none'
        },
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("h3", {
          style: {
            fontSize: 14,
            fontWeight: 400,
            color: '#7C7C7C',
            fontFamily: 'Montserrat'
          },
          children: t('home:button_showall')
        })
      }) : null]
    }), subTitle === undefined ? null : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
      className: "flex items-center mb-4",
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("h3", {
        style: {
          alignSelf: 'flex-start',
          fontSize: 14,
          fontWeight: 400,
          color: '#7C7C7C',
          fontFamily: 'Montserrat'
        },
        children: subTitle
      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .Swiper */ .tq, {
      loop: false,
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 15,
      autoHeight: true,
      breakpoints: {
        700: {
          slidesPerView: 4,
          slidesPerGroup: 4
        }
      },
      children: [list.map(function (item, i) {
        return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .SwiperSlide */ .o5, {
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(ItemComponent, {
            t: t,
            brandInfo: brandInfo,
            type: item.__typename,
            data: item,
            baseUrl: baseUrl === '/services' ? "".concat(baseUrl, "/listing") : baseUrl === '/stores' ? "".concat(baseUrl) : "".concat(baseUrl, "/").concat(item.category)
          })
        }, i);
      }), showArrows ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(MyPagination, {
        slot: "container-end"
      }) : null]
    })]
  });
}

/***/ }),

/***/ 25654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BrandCard; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66242);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83965);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44267);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15861);
/* harmony import */ var _mui_icons_material_Favorite__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36111);
/* harmony import */ var _mui_icons_material_FavoriteBorder__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91811);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);








function BrandCard(_ref) {
  var item = _ref.data,
      className = _ref.className,
      _ref$row = _ref.row,
      row = _ref$row === void 0 ? false : _ref$row,
      _ref$onMouseEnter = _ref.onMouseEnter,
      onMouseEnter = _ref$onMouseEnter === void 0 ? function () {} : _ref$onMouseEnter,
      margin = _ref.margin;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(item.followers),
      follower = _useState[0],
      setFollower = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(item.liked),
      liked = _useState2[0],
      setLiked = _useState2[1];

  var toggleLiked = function toggleLiked() {
    setLiked(!liked);
    setFollower(liked ? follower - 1 : follower + 1);
  };

  var handleImageError = function handleImageError(e) {
    e.target.onerror = null;
    e.target.src = "https://dummyimage.com/640x1:1/eeeeee/333333&text=".concat(item.name);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {// console.log('item: ', item)
  }, []);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
    onMouseEnter: onMouseEnter,
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(row && 'flex', className, 'cursor-pointer'),
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: "/brands/".concat(encodeURIComponent(item.slug), "/").concat(item.id),
      passHref: true,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: "h-340 mb-5 cursor-pointer, shadow-md rounded overflow-hidden p-4",
        sx: {
          marginRight: margin === true ? 5 : 0 // maxWidth: 280,
          // margin: "0 auto",
          // padding: "0.1em",

        },
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)("div", {
          style: {
            position: 'relative'
          },
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            component: "img",
            sx: {
              height: 262,
              padding: "1em 1em 0 1em",
              objectFit: 'contain'
            },
            image: item.logo,
            alt: encodeURIComponent(item.slug),
            onError: handleImageError
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
            onClick: function onClick() {
              return toggleLiked();
            },
            style: {
              position: "absolute",
              top: 10,
              left: "90%",
              transform: "translateX(-50%)",
              cursor: 'pointer'
            },
            children: liked === true ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_icons_material_Favorite__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_icons_material_FavoriteBorder__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
          })]
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            sx: {
              height: 50,
              fontSize: 16,
              fontWeight: 700,
              color: 'black',
              fontFamily: 'Montserrat'
            },
            children: item.name
          })
        })]
      })
    })
  });
}

/***/ }),

/***/ 10800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Discovery; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(50029);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41248);
/* harmony import */ var components_blocks_Wrapper__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(80819);
/* harmony import */ var components_blocks_Container__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(75046);
/* harmony import */ var layouts_Default__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87607);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(86010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var components_MyBreadcrumbs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99690);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(15861);
/* harmony import */ var _utils_WindowDimensions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84322);
/* harmony import */ var components_cards_BrandCard__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25654);
/* harmony import */ var components_MySlider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89973);
/* harmony import */ var lib_features_brandSlice__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(77078);
/* harmony import */ var lib_features_mapSlice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(16226);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(57731);
/* harmony import */ var _data_config_json__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(56513);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(3580);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_utils_helper__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(35944);
























var BRANDS_ROUTE = _data_config_json__WEBPACK_IMPORTED_MODULE_13__/* .brand.route */ .UQ.B;
var BREAD_ROUTE = [{
  label: 'Home',
  href: '/',
  isActive: false
}, {
  label: 'Brands',
  href: '/brands/discovery',
  isActive: true
}];
var __N_SSP = true;
function Discovery(props) {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();

  var _useWindowDimensions = (0,_utils_WindowDimensions__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(),
      height = _useWindowDimensions.height,
      width = _useWindowDimensions.width;

  var brands = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    return state.brand.brands;
  });
  var featuredBrands = brands.slice(0, 12);
  var productBrands = brands.filter(function (item) {
    return item.bizType === 'PRODUCT';
  });
  var serviceBrands = brands.filter(function (item) {
    return item.bizType === 'SERVICE';
  });
  var otherBrands = brands.filter(function (item) {
    return item.bizType === 'OTHERS';
  });
  var storeBrands = brands.filter(function (item) {
    return item.bizType === 'LOCATION';
  });

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      loaded = _useState[0],
      setLoaded = _useState[1];

  var _useTranslation = (0,next_i18next__WEBPACK_IMPORTED_MODULE_12__/* .useTranslation */ .$G)(),
      t = _useTranslation.t;

  function initBrand() {
    return _initBrand.apply(this, arguments);
  }

  function _initBrand() {
    _initBrand = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var sort, page, filter;
      return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              sort = {};
              page = 1;
              filter = {};
              _context.next = 5;
              return dispatch((0,lib_features_brandSlice__WEBPACK_IMPORTED_MODULE_10__/* .getPaginatedBrandsThunk */ .XZ)({
                page: page,
                filter: filter,
                sort: sort
              }));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _initBrand.apply(this, arguments);
  }

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (brands[0].name === 'Test') {
      initBrand();
    } else {
      setLoaded(true);
    }

    return function () {
      console.log('clean up initBrand');
    };
  }, [brands]);

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isMobile = _useState2[0],
      setIsMobile = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (loaded) {
      setIsMobile((0,_utils_helper__WEBPACK_IMPORTED_MODULE_14__.checkMobile)());
    }
  }, [loaded]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .Fragment */ .HY, {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsxs */ .BX)(components_blocks_Wrapper__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)("div", {
        style: {
          width: '100%',
          borderBottom: 'solid thin #DDDDDD'
        },
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsxs */ .BX)(components_blocks_Container__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(components_MyBreadcrumbs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            routeList: BREAD_ROUTE,
            t: t
          }), isMobile ? null : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsxs */ .BX)("h1", {
            style: {
              letterSpacing: 3,
              marginTop: 30,
              marginBottom: 40,
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 700,
              fontSize: 36
            },
            children: [t('home:brandBanner1'), "  ", (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
              sx: {
                marginLeft: 2,
                fontWeight: 400,
                textTransform: 'none',
                fontSize: 30
              },
              children: t('home:footer_slogan')
            })]
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)("nav", {
            className: isMobile ? (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)('flex', 'grow', 'shrink', 'min-w-0', 'overflow-scroll', 'mt-10') : (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)('flex', 'grow', 'shrink', 'min-w-0', 'overflow-hidden'),
            children: BRANDS_ROUTE.map(function (route) {
              return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                href: route.href,
                children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)("a", {
                  style: {
                    fontSize: 14,
                    fontWeight: router.pathname === route.href ? 600 : 400,
                    borderBottom: router.pathname === route.href ? 'solid 2px #108085' : 'unset'
                  },
                  className: isMobile ? (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)('font-normal', 'mr-7', 'last:mr-0', 'leading-5') : (0,clsx__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)('font-normal', 'mr-7', 'last:mr-0', 'leading-10'),
                  children: t("home:".concat(route.label))
                })
              }, route.label);
            })
          })]
        })
      }), loaded ? featuredBrands[0].name === 'Test' ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(components_blocks_Container__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
        style: {
          marginTop: 50
        },
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)("span", {
          children: t('home:pleaseRefresh')
        })
      }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .Fragment */ .HY, {
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsxs */ .BX)(components_blocks_Container__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
          style: {
            marginTop: 50
          },
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(components_MySlider__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            t: t,
            style: {
              marginBottom: 20
            },
            itemComponent: components_cards_BrandCard__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
            dataList: featuredBrands,
            title: t('home:brands_featured_brands'),
            subTitle: t('home:sponsored'),
            showAll: false,
            href: '/brands',
            showArrows: true
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(components_MySlider__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            t: t,
            style: {
              marginBottom: 20
            },
            itemComponent: components_cards_BrandCard__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
            href: '/brands/products',
            dataList: productBrands,
            title: t('home:brands_product_brands'),
            showAll: true,
            showArrows: true
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(components_MySlider__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            t: t,
            style: {
              marginBottom: 20
            },
            itemComponent: components_cards_BrandCard__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
            href: '/brands/services',
            dataList: serviceBrands,
            title: t('home:brands_service_brands'),
            showAll: true,
            showArrows: true
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(components_MySlider__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            t: t,
            style: {
              marginBottom: 20
            },
            itemComponent: components_cards_BrandCard__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
            href: '/brands/stores',
            dataList: storeBrands,
            title: t('home:brands_store_clinic_brands'),
            showAll: true,
            showArrows: true
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(components_MySlider__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            t: t,
            style: {
              marginBottom: 20
            },
            itemComponent: components_cards_BrandCard__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
            href: '/brands/others',
            dataList: otherBrands,
            title: t('home:brands_other_brands'),
            showAll: true
          })]
        })
      }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(components_blocks_Container__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
        style: {
          marginTop: 50
        },
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)("span", {
          children: t('home:loading')
        })
      })]
    })
  });
}

Discovery.getLayout = function getLayout(page) {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(layouts_Default__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    children: page
  });
};

/***/ }),

/***/ 84322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWindowDimensions; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useWindowDimensions() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    width: undefined,
    height: undefined
  }),
      windowSize = _useState[0],
      setWindowSize = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    // only execute all the code below in client side
    if (true) {
      // Handler to call on window resize
      var handleResize = function handleResize() {
        // Set window width/height to state
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      }; // Add event listener


      window.addEventListener("resize", handleResize); // Call handler right away so state gets updated with initial window size

      handleResize(); // Remove event listener on cleanup

      return function () {
        return window.removeEventListener("resize", handleResize);
      };
    }
  }, []); // Empty array ensures that effect is only run on mount

  return windowSize;
}

/***/ }),

/***/ 58711:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/discovery",
      function () {
        return __webpack_require__(10800);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7948,196,3787,9907,7607,9774,2888,179], function() { return __webpack_exec__(58711); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);